import { lazyNamed } from 'src/utils/lazyNamed.ts';

const CompanyDetails = {
  Layout: lazyNamed(() => import('./components/Layout.tsx'), 'Layout'),
  AccountsList: lazyNamed(() => import('./containers/AccountsList/index.tsx'), 'AccountsList'),
  EmailSyncExclusionsList: lazyNamed(() => import('./containers/EmailSyncExclusionsList/index.tsx'), 'EmailSyncExclusionsList'),
  PermissionsList: lazyNamed(() => import('./containers/PermissionsList/index.tsx'), 'PermissionsList'),
  ProgrammaticSeatsList: lazyNamed(() => import('./containers/ProgrammaticSeatsList/index.tsx'), 'ProgrammaticSeatsList'),
  WebsitesList: lazyNamed(() => import('./containers/WebsitesList/index.tsx'), 'WebsitesList'),
  UserGroupsList: lazyNamed(() => import('./containers/UserGroupsList/index.tsx'), 'UserGroupsList'),
};

export default CompanyDetails;
